export enum PathnameEnum {
  BACKOFFICE_USERS = '/usuarios-backoffice',
  COMPANY = '/empresas',
  USER = 'usuarios',
}
